<template>
  <div class="absolute -top-1.5 left-178 z-10 w-20 h-12.5">
    <div class="z-11 absolute top-0 left-0 w-20 h-10 rounded-md bg-[#d4dff6]" :style="styles" />
    <div class="z-10 absolute top-2.5 left-0 w-20 h-10 rounded-md bg-white" />
  </div>
</template>

<script setup lang="ts">
  import type { CSSProperties } from 'vue'

  withDefaults(
    defineProps<{
      /** 灯光页传入发光样式；不传则不显示指示灯灯效 */
      styles?: CSSProperties
    }>(),
    {
      styles: () => ({}),
    },
  )
</script>

<style scoped></style>
